/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``mail.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const MailIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="evenodd"
        d="M5.06903 2.25H12.931C13.5347 2.24999 14.033 2.24998 14.4389 2.28315C14.8604 2.31759 15.248 2.39151 15.612 2.57698C16.1765 2.8646 16.6354 3.32354 16.923 3.88803C17.102 4.23929 17.1771 4.61245 17.2131 5.01698C17.2532 5.13953 17.2602 5.26879 17.2364 5.3922C17.25 5.72979 17.25 6.12027 17.25 6.56901V11.431C17.25 12.0347 17.25 12.533 17.2169 12.9389C17.1824 13.3604 17.1085 13.748 16.923 14.112C16.6354 14.6765 16.1765 15.1354 15.612 15.423C15.248 15.6085 14.8604 15.6824 14.4389 15.7169C14.033 15.75 13.5347 15.75 12.931 15.75H5.06901C4.46529 15.75 3.96702 15.75 3.56113 15.7169C3.13956 15.6824 2.75203 15.6085 2.38803 15.423C1.82354 15.1354 1.3646 14.6765 1.07698 14.112C0.891512 13.748 0.817589 13.3604 0.783145 12.9389C0.749982 12.533 0.74999 12.0347 0.749999 11.431V6.56903C0.749992 6.12028 0.749986 5.72979 0.763602 5.3922C0.739785 5.26879 0.746815 5.13952 0.786911 5.01697C0.822902 4.61245 0.898006 4.23929 1.07698 3.88803C1.3646 3.32354 1.82354 2.8646 2.38803 2.57698C2.75203 2.39151 3.13956 2.31759 3.56113 2.28315C3.96703 2.24998 4.4653 2.24999 5.06903 2.25ZM2.25 6.69049V11.4C2.25 12.0424 2.25058 12.4792 2.27816 12.8167C2.30503 13.1455 2.35372 13.3137 2.41349 13.431C2.5573 13.7132 2.78677 13.9427 3.06901 14.0865C3.18631 14.1463 3.35447 14.195 3.68328 14.2218C4.02085 14.2494 4.45757 14.25 5.1 14.25H12.9C13.5424 14.25 13.9792 14.2494 14.3167 14.2218C14.6455 14.195 14.8137 14.1463 14.931 14.0865C15.2132 13.9427 15.4427 13.7132 15.5865 13.431C15.6463 13.3137 15.695 13.1455 15.7218 12.8167C15.7494 12.4792 15.75 12.0424 15.75 11.4V6.69049L10.8064 10.151C10.7773 10.1714 10.7485 10.1916 10.7199 10.2117C10.3114 10.4985 9.95272 10.7504 9.5442 10.8522C9.18687 10.9413 8.81313 10.9413 8.4558 10.8522C8.04728 10.7504 7.68859 10.4985 7.2801 10.2117C7.25152 10.1916 7.2227 10.1714 7.19359 10.151L2.25 6.69049ZM15.6879 4.90296L9.94621 8.92216C9.39951 9.30485 9.28368 9.37125 9.1814 9.39675C9.06229 9.42644 8.93771 9.42644 8.8186 9.39675C8.71632 9.37125 8.60049 9.30485 8.05379 8.92216L2.31208 4.90296C2.33887 4.74759 2.37373 4.64705 2.41349 4.56902C2.5573 4.28677 2.78677 4.0573 3.06901 3.91349C3.18631 3.85372 3.35447 3.80503 3.68328 3.77816C4.02085 3.75058 4.45757 3.75 5.1 3.75H12.9C13.5424 3.75 13.9792 3.75058 14.3167 3.77816C14.6455 3.80503 14.8137 3.85372 14.931 3.91349C15.2132 4.0573 15.4427 4.28677 15.5865 4.56902C15.6263 4.64705 15.6611 4.74759 15.6879 4.90296Z"
        transform=""
      />
    </g>
  </svg>
);

MailIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

MailIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

MailIcon.displayName = "MailIcon";

export default MailIcon;
